import { Package } from "lucide-react";

// True when a cart/track item means the customer is supplying their own goods.
export const itemNeedsDropOff = (i) =>
  i?.categorySlug === "customized-sneakers" ||
  /customer supplies/i.test(i?.configLabel || i?.config || "") ||
  /sneaker/i.test(i?.name || "");

// The 3-step drop-off checklist content (shared by the configurator accordion
// and the post-purchase confirmation screens).
export const DropOffChecklist = ({ sneaker = false }) => (
  <div data-testid="dropoff-checklist">
    <p className="text-sm leading-relaxed text-zinc-200">
      Thank you for choosing to provide your own materials! To ensure maximum print adhesion and
      zero production delays, please follow our drop-off checklist:
    </p>
    <ol className="mt-4 space-y-3">
      <li className="text-sm leading-relaxed text-zinc-300">
        <span className="font-mono text-xs font-bold uppercase tracking-wider text-brand-cyan">1. Material Preparation:</span>{" "}
        {sneaker
          ? "Footwear must be thoroughly cleaned with all surface dirt and oils removed before drop-off."
          : "All garments must be brand new or freshly washed, 100% dry, and completely free of fabric softeners, lint, or pet hair."}
      </li>
      <li className="text-sm leading-relaxed text-zinc-300">
        <span className="font-mono text-xs font-bold uppercase tracking-wider text-brand-cyan">2. Drop-Off Location & Hours:</span>{" "}
        Bring your items directly to our studio at{" "}
        <span className="font-bold text-white">24 Upper Elleston Road, Kingston 16</span>.
        Drop-offs are accepted Monday through Friday between 9:00 AM and 5:00 PM.
      </li>
      <li className="text-sm leading-relaxed text-zinc-300">
        <span className="font-mono text-xs font-bold uppercase tracking-wider text-brand-cyan">3. Intake Labeling:</span>{" "}
        Please place your items securely in a bag clearly labeled with your Full Name, Phone
        Number, and the unique Order ID generated at checkout.
      </li>
    </ol>
    <p className="mt-4 border-t border-white/10 pt-3 font-mono text-[11px] uppercase tracking-wider text-zinc-400">
      Production turnaround times begin once your physical items are officially logged into our
      intake system at the studio.
    </p>
  </div>
);

// Full framed block for post-purchase confirmation screens.
export const DropOffBlock = ({ sneaker = false }) => (
  <section data-testid="dropoff-block" className="border-2 border-brand-yellow/60 bg-brand-yellow/5 text-left">
    <div className="flex items-center gap-3 border-b border-brand-yellow/30 bg-brand-yellow/10 px-5 py-3.5">
      <Package className="h-5 w-5 shrink-0 text-brand-yellow" />
      <h3 className="font-display text-lg font-black uppercase tracking-wide text-brand-yellow">
        {sneaker ? "Sneaker Drop-Off Instructions" : "Client Garment Drop-Off Instructions"}
      </h3>
    </div>
    <div className="px-5 py-4">
      <DropOffChecklist sneaker={sneaker} />
    </div>
  </section>
);
